import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8.165 8.174a4 4 0 0 0 -5.166 3.826a4 4 0 0 0 6.829 2.828a10 10 0 0 0 2.172 -2.828m1.677 -2.347a10 10 0 0 1 .495 -.481a4 4 0 1 1 5.129 6.1m-3.521 .537a4 4 0 0 1 -1.608 -.981a10 10 0 0 1 -2.172 -2.828","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconInfinityOff = createReactComponent('outline', 'infinity-off', 'InfinityOff', __iconNode);

export default IconInfinityOff;